const observer = new IntersectionObserver((entries, observer) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      const el = entry.target;
      const span = el.querySelector('span');
      if (!span) return;

      const target = parseInt(span.textContent, 10);
      let count = 0;

      const duration = 3000; // durée d'animation en ms
      const frameRate = 60;
      const totalFrames = Math.round((duration / 1000) * frameRate);
      const increment = target / totalFrames;

      const updateCount = () => {
        count += increment;
        if (count >= target) {
          span.textContent = target;
        } else {
          span.textContent = Math.round(count);
          requestAnimationFrame(updateCount);
        }
      };

      updateCount();

      observer.unobserve(el); // Ne pas réanimer si on rescrolle dessus plus tard
    }
  });
}, {
  threshold: 0.3, // Le bloc doit être à 30% visible avant de lancer l'animation
});

document.querySelectorAll('.wp-block-a-animated-number').forEach((el) => {
  observer.observe(el);
});
